function GreenLabel(props: any) {
  return <label className="success-label">{props.successLabel}</label>;
}

export default GreenLabel;
